import React from 'react'

import './container.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    size?: 'full' | 'l' | 'm' | 's'
  }
>

const Container = ({className, children, size = 'full', ...props}: Props) => (
  <div {...props} className={cn('Container', {[`size-${size}`]: true}, className)}>
    {children}
  </div>
)

export default Container
